import { Injectable } from '@angular/core';
import { NotificationService } from 'beyond-util';
import { ValidationService } from '../../../../services/validation.service';

@Injectable()
export class KorisniciValidationService {
  constructor(
    private _notificationService: NotificationService,
    private _validationService: ValidationService
  ) {}

  validateCreateUpdate(order: any, uloge) {
    let isValid = true;

    if (!this.validateUloge(uloge)) {
      this.notify('Potrebno je uneti bar jednu korisničku ulogu.');

      isValid = false;
    }

    if (!this._validationService.validateEmail(order.Email)) {
      this.notify('Niste uneli dobar format za email.');

      isValid = false;
    }

    return isValid;
  }

  validateUloge(uloge) {
    return uloge && uloge.length;
  }

  notify(message: string) {
    this._notificationService.notyError(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/korisnici/services/korisnici-validation.service.ts